import { Typography } from 'antd'
import { Trans, useTranslation } from 'react-i18next'

type Props = {
  total: number
  current: number
}

function FormStepper({ total, current }: Props) {
  const { i18n } = useTranslation()

  return (
    <Typography.Text data-testid="form-stepper">
      <Trans
        i18n={i18n}
        i18nKey="form.stepper"
        components={[<strong />]}
        tOptions={{ current, total }}
      />
    </Typography.Text>
  )
}

export default FormStepper
